import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type UpdateCitizenshipOperation = paths['/executor_web/identification/citizenship']['patch'];

export type UpdateCitizenshipRequest = NonNullable<
	NonNullable<UpdateCitizenshipOperation['requestBody']>['content']['application/json']
>;
export type UpdateCitizenshipResponse =
	UpdateCitizenshipOperation['responses'][200]['content']['application/json'];

/** PATCH `/executor_web/identification/citizenship` — см. `paths['/executor_web/identification/citizenship']` в auth swagger */
export function updateCitizenship(request: UpdateCitizenshipRequest, signal?: AbortSignal) {
	return axiosInstance.patch<UpdateCitizenshipResponse>('identification/citizenship', request, {signal});
}
